
import { ref, watch } from '@vue/composition-api';
import Nationality from "@/models/Nationality";
import IdType from "@/models/IdType";

export default function useNomineeDirectorHandler(props, emit) {
    const nomineeDirectorLocal = ref(JSON.parse(JSON.stringify(props.nomineeDirector.value)));    

    const resetNomineeDirectorLocal = () => {
        nomineeDirectorLocal.value = JSON.parse(JSON.stringify(props.nomineeDirector.value));
    };

    watch(props.nomineeDirector, () => {
        resetNomineeDirectorLocal();
    });

    const onSubmit = () => {
        const nomineeDirector = JSON.parse(JSON.stringify(nomineeDirectorLocal));

        // * If event has id => Edit Event
        // Emit event for add/update event
        if (props.nomineeDirector.value.id) emit('update-nominee-director', nomineeDirector.value);
        else emit('add-nominee-director', nomineeDirector.value);
    };

    // Nationality Option
    // eslint-disable-next-line camelcase
    const nationality_options= ref([]);

    const getNationality = async() =>{
        const nationalities = await Nationality.all();
        nationality_options.value = nationalities.map(obj => ({
            id: obj.id,
            nationality: obj.name
        }));
    };
    getNationality();

    // get id type options
    const idTypeOptions = ref([]);

    const getIdTypes = async() => {
        idTypeOptions.value = await IdType.all();
    };
    getIdTypes();

    if (nomineeDirectorLocal.value.nationality)
    // eslint-disable-next-line prefer-destructuring
        nomineeDirectorLocal.value.nationality = nationality_options.value.filter(
            opt => opt.value === nomineeDirectorLocal.value.nationality
        )[0]; 

    return {
        nomineeDirectorLocal,
        resetNomineeDirectorLocal,
        nationality_options,
        idTypeOptions,

        // UI
        onSubmit,
    };
}
